import { Injectable, NgZone } from '@angular/core';
import { fromEvent, merge, Observable, timer } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { AuthService } from '../../core/auth.service';

@Injectable({
  providedIn: 'root'
})
export class UserIdleService {
  private readonly idleTimeout = 20 * 60 * 1000;
  private idleTimer$: Observable<any>;

  constructor(private authService: AuthService, private ngZone: NgZone) {
    this.idleTimer$ = merge(
      fromEvent(document, 'keydown'),
      fromEvent(document, 'click'),
      fromEvent(document, 'touchstart')
    ).pipe(
      tap(() => console.log('Zrestartuj timer')),
      switchMap(() => timer(this.idleTimeout))
    );

    this.startWatching();
  }

  startWatching() {
    this.ngZone.runOutsideAngular(() => {
      this.idleTimer$.subscribe(() => this.onTimeout());
    });
  }

  private onTimeout() {
    this.ngZone.run(() => {
      this.authService.logout();
    });
  }
}
